(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-beauty-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTimeline = (scope = document) => {
      scope.querySelectorAll('[data-vora-timeline-section]').forEach((section) => {
        if (section.dataset.timelineReady === 'true') return;
        section.dataset.timelineReady = 'true';

        const steps = Array.from(section.querySelectorAll('[data-vora-timeline-step]'));
        if (!steps.length) return;

        let frameRequested = false;

        const updateTimeline = () => {
          frameRequested = false;
          const marker = window.innerHeight * 0.55;
          const sectionRect = section.getBoundingClientRect();
          let activeIndex = 0;

          if (sectionRect.top <= marker) {
            steps.forEach((step, index) => {
              if (step.getBoundingClientRect().top <= marker) activeIndex = index;
            });
          }

          const activeWeek = activeIndex + 1;
          const progress = steps.length > 1 ? activeIndex / (steps.length - 1) * 100 : 100;
          section.dataset.activeWeek = String(activeWeek);
          section.style.setProperty('--vora-timeline-progress', `${progress}%`);

          steps.forEach((step, index) => {
            step.classList.toggle('is-active', index === activeIndex);
            step.classList.toggle('is-complete', index < activeIndex);
          });
        };

        const requestUpdate = () => {
          if (frameRequested) return;
          frameRequested = true;
          window.requestAnimationFrame(updateTimeline);
        };

        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);
        section.timelineCleanup = () => {
          window.removeEventListener('scroll', requestUpdate);
          window.removeEventListener('resize', requestUpdate);
        };
        updateTimeline();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeTimeline());
    } else {
      initializeTimeline();
    }

    document.addEventListener('shopify:section:load', (event) => initializeTimeline(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-vora-timeline-section]');
      if (section && section.timelineCleanup) section.timelineCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-vba-stage]').forEach((stage) => {
      if (stage.dataset.ready === 'true') return;
      stage.dataset.ready = 'true';
      const range = stage.querySelector('[data-vba-range]');
      if (!range) return;
      const update = () => stage.closest('.vba').style.setProperty('--vba-split', `${range.value}%`);
      range.addEventListener('input', update, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-body-benefits-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.vbb');
    sections.forEach((section) => {
      if (section.dataset.vbbReady === 'true') return;
      section.dataset.vbbReady = 'true';
      const scenes = section.querySelectorAll('[data-vbb-scene]');
      if (!('IntersectionObserver' in window)) {
        scenes.forEach((scene) => scene.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      }, { threshold: .3, rootMargin: '0px 0px -8% 0px' });
      scenes.forEach((scene) => observer.observe(scene));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-how-to-scroll"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vhs').forEach(function(section){
    const steps=Array.from(section.querySelectorAll('[data-vhs-step]'));
    if(!('IntersectionObserver' in window)){
      steps.forEach(function(step){step.classList.add('is-visible')});
      return;
    }
    const observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting)entry.target.classList.add('is-visible');
        else if(entry.boundingClientRect.top>0)entry.target.classList.remove('is-visible');
      });
    },{threshold:.3,rootMargin:'0px 0px -8% 0px'});
    steps.forEach(function(step){observer.observe(step)});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-lifestyle-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', function(event) {
    const opened = event.target;
    if (!opened.matches('.vora-faq__item') || !opened.open) return;
    const section = opened.closest('.vora-faq');
    section.querySelectorAll('.vora-faq__item[open]').forEach(function(item) {
      if (item !== opened) item.open = false;
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-premium-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-vora-localization]')) return;
    event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-product-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){
    const trigger=event.target.closest('[data-vpa-trigger]');
    if(!trigger)return;
    const accordion=trigger.closest('.vpa');
    const item=trigger.closest('[data-vpa-item]');
    const willOpen=!item.classList.contains('is-open');
    accordion.querySelectorAll('[data-vpa-item]').forEach(function(other){
      other.classList.remove('is-open');
      const otherTrigger=other.querySelector('[data-vpa-trigger]');
      if(otherTrigger)otherTrigger.setAttribute('aria-expanded','false');
    });
    if(willOpen){
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded','true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(e){
    const thumb=e.target.closest('[data-vph-thumb]'); if(!thumb)return;
    const section=thumb.closest('.vph'); const index=thumb.dataset.vphThumb;
    section.querySelectorAll('[data-vph-thumb]').forEach(el=>el.classList.toggle('is-active',el.dataset.vphThumb===index));
    section.querySelectorAll('[data-vph-slide]').forEach(el=>el.classList.toggle('is-active',el.dataset.vphSlide===index));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-social-videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){
    const section=event.target.closest('.vsv');
    if(!section)return;
    const track=section.querySelector('[data-vsv-track]');
    const prev=event.target.closest('[data-vsv-prev]');
    const next=event.target.closest('[data-vsv-next]');
    if(prev||next){
      track.scrollBy({left:(next?1:-1)*track.clientWidth*.82,behavior:'smooth'});
      return;
    }
    const opener=event.target.closest('[data-vsv-open]');
    const modal=section.querySelector('[data-vsv-modal]');
    const media=section.querySelector('[data-vsv-modal-media]');
    if(opener){
      const template=document.getElementById(opener.dataset.vsvOpen);
      if(!template)return;
      media.replaceChildren(template.content.cloneNode(true));
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow='hidden';
      section._vsvLastTrigger=opener;
      section.querySelector('[data-vsv-close].vsv__close').focus();
      return;
    }
    if(event.target.closest('[data-vsv-close]')){
      media.replaceChildren();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow='';
      if(section._vsvLastTrigger)section._vsvLastTrigger.focus();
    }
  });
  document.addEventListener('keydown',function(event){
    if(event.key!=='Escape')return;
    const modal=document.querySelector('.vsv__modal.is-open');
    if(!modal)return;
    modal.querySelector('[data-vsv-close]').click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-vsc]').forEach((bar) => {
      if (bar.dataset.ready === 'true') return;
      bar.dataset.ready = 'true';
      const sectionId = bar.id.replace('VoraStickyCart-', '');
      const variantsNode = document.querySelector(`[data-vsc-variants="${sectionId}"]`);
      const variantInput = bar.querySelector('[data-vsc-variant]');
      const price = bar.querySelector('[data-vsc-price]');
      const button = bar.querySelector('[data-vsc-button]');
      const buttonText = bar.querySelector('[data-vsc-button-text]');
      let variants = [];
      try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (error) { variants = []; }

      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
      const sync = (id) => {
        const variant = variants.find((item) => String(item.id) === String(id));
        if (!variant) return;
        variantInput.value = variant.id;
        price.textContent = money(variant.price);
        button.disabled = !variant.available;
        buttonText.textContent = variant.available ? buttonText.dataset.available : buttonText.dataset.soldOut;
      };

      document.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"], select[name="id"]') && !bar.contains(event.target)) sync(event.target.value);
      });
      document.addEventListener('variant:change', (event) => sync(event.detail?.variant?.id));

      const updateVisibility = () => {
        const purchaseButton = document.querySelector('form[action*="/cart/add"] button[name="add"]');
        const threshold = purchaseButton ? purchaseButton.getBoundingClientRect().bottom : 520;
        bar.classList.toggle('is-visible', threshold < 0 || window.scrollY > 520);
      };
      updateVisibility();
      window.addEventListener('scroll', updateVisibility, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vora-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.vora-reviews__arrow');
    if (!button) return;
    const section = button.closest('.vora-reviews');
    const track = section.querySelector('.vora-reviews__track');
    const card = track.querySelector('.vora-review-card');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
    const direction = button.classList.contains('vora-reviews__arrow--next') ? 1 : -1;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
